// extracted by mini-css-extract-plugin
export var currencyInput = "_j3-1";
export var currencySymbol = "_j3-0";